import React from 'react';
import UpcomingGroupToursContainer from "./UpcomingGroupToursContainer";

import georgia from "../../images/tours/georgia/pexels-andrew-schwark-540305-12916337.jpg";
import lofoten from "../../images/tours/lofoten.jpg";
import como from "../../images/privateCountries/como.webp";
import portugal from "../../images/tours/Portugal.jpg";
import iceland from "../../images/tours/iceland.jpg";
import faroe from "../../images/tours/faroe-islands-europes-otherworldly-best-kept-secret-1200x720.jpg";
import vietnam from "../../images/tours/vietnam.jpeg";
import norway from "../../images/norway.jpg";


const tours = [
    {
        id: 1,
        title: "georgia",
        country: "georgia",
        description: "georgia_description_title",
        price: 'georgia_price',
        dateText: "georgia_date",
        date: "georgia_date_calendar",
        image: georgia,
        page: "/destinations/georgia",
        active: true,
        // label: 'VIP'
    },
    {
        id: 2,
        title: "lofoten",
        country: "lofoten",
        description: "lofoten_description_title",
        price: 'lofoten_price',
        dateText: "lofoten_date",
        date: "lofoten_date_calendar",
        image: lofoten,
        page: "/destinations/lofoten",
        active: true,
        // label: 'Premiuim'
    },
    {
        id: 3,
        title: "portugal",
        country: "portugal",
        description: "portugal_description_title",
        price: 'portugal_price',
        dateText: "portugal_date",
        date: "portugal_date_calendar",
        image: portugal,
        page: "/destinations/portugal",
        active: true,
        // label: 'Для лошків'
    },
    {
        id: 4,
        title: "italy",
        country: "italy_como",
        description: "italy_como_description_title",
        price: 'italy_como_price',
        dateText: "italy_como_date",
        date: "italy_como_date_calendar",
        image: como,
        page: "/destinations/italy/como",
        active: true,
        // label: 'Для лошків'
    },
    {
        id: 5,
        title: "iceland",
        country: "iceland",
        description: "iceland_description_title",
        price: 'iceland_price',
        dateText: "iceland_date",
        date: "iceland_date_calendar",
        image: iceland,
        page: "/destinations/iceland",
        active: true,
        // label: 'VIP'
    },
    {
        id: 6,
        title: "faroe",
        country: "faroe",
        description: "faroe_upcoming",
        price: 'faroe_price',
        dateText: "faroe_date",
        date: "faroe_date_calendar",
        image: faroe,
        page: "/destinations/faroe",
        active: true,
        // label: 'Для лошків'
    },
    {
        id: 7,
        title: "vietnam",
        country: "vietnam",
        // description: "Experience breathtaking views, charming villages, and world-class hiking trails in the Swiss Alps.",
        // price: 1200,
        date: "vietnam_date_calendar",
        image: vietnam,
        // page: "/destinations/faroe",
        active: false,
        // label: 'Для лошків'
    },
    {
        id: 8,
        title: "norway",
        country: "norway",
        description: "norway_description_title",
        price: 'norway_price',
        dateText: "norway_date",
        date: "norway_date_calendar",
        image: norway,
        page: "/destinations/norway",
        active: true,
    },
];

const UpcomingGroupTourSections = ({titleVariant}) => {
    return (
        <UpcomingGroupToursContainer title={'label_upcoming_group_tours'} tours={tours}
                                     titleVariant={titleVariant}/>
    );
};

export default UpcomingGroupTourSections;
